import { jsx as e } from "react/jsx-runtime";
import "react";
import { ImageCard as i } from "../ImageCard/ImageCard.js";
import { Loading as p } from "../Loading/Loading.js";
import { AirDateFormatter as c } from "../AirDateFormatter/AirDateFormatter.js";
import { convert12to24 as u } from "../../utils/helpers.js";
import { determineSeriesPrefix as s } from "../../utils/program-helpers.js";
import '../../assets/FeaturedList.css';function y({
  list: a = [],
  imageAspectRatio: n = 800 / 1393,
  hasSeriesPages: o = !0,
  handleClicks: d = () => {
  }
}) {
  if (a === null) return /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(p, {}) });
  if (a.length) return /* @__PURE__ */ e("featured-list", { children: a.map((r) => {
    var l, t;
    return /* @__PURE__ */ e(
      i,
      {
        image: {
          url: ((l = r == null ? void 0 : r.content) == null ? void 0 : l.image) ?? "",
          aspectRatio: n,
          altText: r.program
        },
        content: /* @__PURE__ */ e(c, { airdateStr: `${r.start_date} ${u(r.start_time)}`, separatorType: "pipe" }),
        fullCardClickable: !0,
        handleClicks: o ? () => {
        } : d,
        cta: {
          label: "View Upcoming",
          href: (t = r == null ? void 0 : r.content) != null && t.slug && o ? r.program_class === "Film" ? `/movie/${r.content.slug}` : `/show/${r.content.slug}` : "",
          type: o ? "internal-link" : "show-modal",
          relatedResourceId: r.program_class === "Film" ? r.title_code : s(r.series_prefix),
          relatedResourceType: r.program_class === "Film" ? "film" : "series"
        },
        relatedResourceId: r.program_class === "Film" ? r.title_code : s(r.series_prefix),
        displayCTA: !1
      },
      `featured-list-${r.id}`
    );
  }) });
  if (!a.length) return /* @__PURE__ */ e("div", { className: "featured-list__no-results", children: "There are no items to display." });
}
export {
  y as FeaturedList,
  y as default
};
